<span>{{ userName() }}</span>
<button
  matTooltip="Mon profil"
  mat-icon-button
  [matMenuTriggerFor]="accountMenu"
  class="app-button"
  aria-label="Menu mon profil"
>
  <mat-icon>account_circle</mat-icon>
</button>
<span class="version">v{{ version }}</span>

<mat-menu #accountMenu="matMenu">
  <ng-content select="[menu-user-items]"></ng-content>
  <app-user-management-menu-item></app-user-management-menu-item>
  <app-logout-menu-item></app-logout-menu-item>
</mat-menu>
